import { token } from "functions/Helper";
import InActiveList from "views/BusinessCategory/InActive";
import InDraft from "views/BusinessCategory/InDraft";
import Published from "views/BusinessCategory/Published";
import CategoryIcon from "@material-ui/icons/Category";
import { CreateBusinessCategory } from "views/BusinessCategory/Create";
import { EditBusinessCategory } from "views/BusinessCategory/Edit";
import { DeleteBusinessCategory } from "views/BusinessCategory/Delete";
import { ViewBusinessCategory } from "views/BusinessCategory/View";
import { PublishBusinessCategory } from "views/BusinessCategory/Publish";
import { DeactivateBusinessCategory } from "views/BusinessCategory/Deactivate";

const businessCategory = () => {
  let views = [];

  if (
    token["master.business_categories.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/BusinessCategory/InDraft",
        name: "InDraft",
        mini: "ID",
        component: InDraft,
        layout: "/admin"
      },
      {
        path: "/BusinessCategory/Published",
        name: "Published",
        mini: "PU",
        component: Published,
        layout: "/admin"
      },
      {
        path: "/BusinessCategory/InActive",
        name: "InActive",
        mini: "IA",
        component: InActiveList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Business Category",
        icon: CategoryIcon,
        state: "BusinessCategoryCollapse",
        views: views
      }
    ];
  return [];
};

const businessCategoryHidden = () => {
  let views = [];

  if (
    token["master.business_categories.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/BusinessCategory/Create",
        name: "Create Business Category",
        component: CreateBusinessCategory,
        layout: "/admin"
      },
      {
        path: "/BusinessCategory/Edit",
        name: "Edit Business Category",
        component: EditBusinessCategory,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/BusinessCategory/Delete",
        name: "Delete Business Category",
        component: DeleteBusinessCategory,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (
    token["master.business_categories.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/BusinessCategory/Detail",
      name: "View Business Category",
      component: ViewBusinessCategory,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.business_categories.publish"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/BusinessCategory/Publish",
      name: "Publish Business Category",
      component: PublishBusinessCategory,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.business_categories.deactivate"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/BusinessCategory/Deactivate",
      name: "Deactivate Business Category",
      component: DeactivateBusinessCategory,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Business Category Hidden",
        state: "businessCategoryHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { businessCategory, businessCategoryHidden };
